<template>
  <div>
    <v-layout>
      <v-flex xs12 md12>
        <v-layout row wrap class="pl-10">
          <input type="file" ref="fileInput" style="display:none" @change="getSelectedImage()" />
          <v-flex xs12 md3 class="my-5">
            <v-card class="pa-0" v-if="folder" min-width="150">
              <v-img :src="selectedImage" height="100px"></v-img>

              <v-card-actions>
                <v-btn
                  outlined
                  rounded
                  dark
                  color="indigo"
                  v-if="folder"
                  x-small
                  @click="$refs.fileInput.click()"
                >Select</v-btn>
                <v-btn
                  class="my-2"
                  outlined
                  rounded
                  dark
                  :color="getThemeColor"
                  v-if="selectedImage"
                  x-small
                  @click="uploadImage()"
                >Upload</v-btn>
              </v-card-actions>
            </v-card>
            <Loader></Loader>
          </v-flex>
          <v-flex
            v-for="(image,i) in images"
            :key="i+Math.random()+Math.random()"
            xs12
            md3
            class="mx-5 my-6"
          >
            <v-card class="pa-0" dark shaped>
              <v-img
                :src="$store.state.apiUrl+'/images/'+folder+'/'+getUserSchool.emis+'/'+image"
                height="100px"
              ></v-img>

              <v-card-actions>
                <v-btn
                  outlined
                  :style="{'color':getThemeColor}"
                  rounded
                  @click="replaceImg(image)"
                  x-small
                >Replace</v-btn>
                <v-btn outlined color="red" rounded @click="deleteImg(image)" x-small>Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
export default {
  props: ["folder"],
  components: { Loader },
  mounted() {
    this.getImages();
  },
  updated() {
    this.imageToBeReplaced = null;
  },
  watch: {
    folder(newVal, oldVal) {
      this.getImages();
    }
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },
  data() {
    return {
      selectedImage: "https://api.baronitsolution.com/images/add_image.png",
      selectedImageName: null,
      images: [],
      imageToBeReplaced: null
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    replaceImg(image) {
      this.imageToBeReplaced = image;
      this.$refs.fileInput.click();
    },

    deleteImg(image) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-image",
          { image: image, folder: this.folder },
          this.getAccessToken
        )
        .then(images => {
          this.$store.commit("setLoader", false);
          this.images = images;
        });
    },
    getSelectedImage() {
      const file = event.target.files[0];
      this.selectedImageName = file.name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedImage = fileReader.result;
        if (this.imageToBeReplaced != null) {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/replace-image",
              {
                image64: fileReader.result,
                folder: this.folder,
                oldName: this.imageToBeReplaced,
                newName: this.selectedImageName
              },
              this.getAccessToken
            )
            .then(images => {
              this.$store.commit("setLoader", false);
              this.images = images;
            });
        }
      });
      fileReader.readAsDataURL(file);
    },
    uploadImage() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/upload-image",
          {
            image64: this.selectedImage,
            name: this.selectedImageName,
            folder: this.folder
          },
          this.getAccessToken
        )
        .then(images => {
          this.$store.commit("setLoader", false);
          this.images = images;
        });
    },
    getImages() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-images-for-given-folder",
          {
            folder: this.folder
          },
          this.getAccessToken
        )
        .then(images => {
          this.images = images;
          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>